import * as React from "react";

import { DotGridBackground } from "@replohq/lattice/blocks/theme-picker/DotGridBackground";

import { BetaShowcasePanel } from "../BetaShowcasePanel";

export const AgentBetaPageShell: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <div className="flex min-h-screen w-full flex-col lg:h-screen lg:flex-row lg:overflow-hidden">
      <div className="hidden lg:block lg:h-full lg:w-1/2">
        <BetaShowcasePanel />
      </div>
      <div className="relative flex w-full flex-1 flex-col items-center justify-center overflow-y-auto bg-surface px-4 py-12 lg:w-1/2">
        <DotGridBackground mode="light" />
        <img
          src="/images/onboarding/replo-wordmark-black.svg"
          alt="Replo"
          className="absolute left-5 top-5 h-7 w-auto md:left-8 md:top-7"
        />
        <main className="relative z-10 w-full max-w-md">{children}</main>
      </div>
    </div>
  );
};
